import { PreviewState } from "./usePreviewSelector";

type SizeArg = { width: number; height: number };

function getNewWindowSize(prevSize: SizeArg, sizeUpdate: SizeArg) {
  const newWidth = prevSize.width + sizeUpdate.width;
  const newHeight = prevSize.height + sizeUpdate.height;

  return {
    width: newWidth,
    height: newHeight,
  };
}

function getNewWindowLocation(
  event: any,
  dialogWidth: number,
  dialogHeight: number,
  preview: PreviewState
) {
  const x = Math.min(
    Math.max(0, event.pageX - (preview.rel?.x ? preview.rel.x : 0)),
    window.innerWidth - dialogWidth - 20
  );
  const y = Math.min(
    Math.max(0, event.pageY - (preview.rel?.y ? preview.rel.y : 0)),
    window.innerHeight - dialogHeight - 20
  );
  return {
    ...preview,
    x,
    y,
  };
}

export { getNewWindowSize, getNewWindowLocation };
